import { Confetti } from "../Confetti";
import { TrophiesContainer } from "./TrophiesContainer";
import { TrophyIconsContainer } from "./TrophyIconsContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { IntroReporter } from "./IntroReporter";
import { AudioManager, SoundTrack } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class TrophyState extends Phaser.State {

    public static currentInstance: TrophyState;

    public matchSelected: boolean;
    public confetti: Confetti;

    private blackLayer: Phaser.Sprite;
    private trophiesContainer: TrophiesContainer;
    private backButton: Phaser.Button;
    private upSlideButton: Phaser.Button;
    private downSlideButton: Phaser.Button;
    private creditsLabel: Phaser.Text;
    private trophyIconsContainer: TrophyIconsContainer;

    public create(): void {

        TrophyState.currentInstance = this;

        this.stage.disableVisibilityChange = true;

        this.matchSelected = false;

        const backgroundImage = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "lawn-background");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.set(1.45, -1.45 * GameVars.scaleY * GameVars.fieldCorrectionScaleY);

        this.trophiesContainer = new TrophiesContainer(this.game);
        this.add.existing(this.trophiesContainer);

        this.addFrame();

        this.trophyIconsContainer = new TrophyIconsContainer(this.game);
        this.add.existing(this.trophyIconsContainer);

        if (GameVars.gameData.introSeen) {
            this.trophyIconsContainer.init();
        } else {
            
            let introReporter = new IntroReporter(this.game);
            this.add.existing(introReporter);

            this.trophiesContainer.visible = false;
            this.trophyIconsContainer.initIntroConfiguration();
        }

        // una etiqueta con el dinero disponible
        this.addCredits();

        const backButton_py = 15 * GameVars.scaleY;
        
        this.backButton = new Phaser.Button(this.game, 15, backButton_py, "texture_atlas_5", this.onClickBackButton, this, 1, 0, 1);
        this.backButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on", "exit_button_off");
        this.backButton.scale.set(.85, .85 * GameVars.scaleY);
        this.add.existing(this.backButton );

        // las flechas si se trata de un desktop
        if ( this.game.device.desktop ) {
            this.upSlideButton = new Phaser.Button(this.game, 710, 95, "texture_atlas_5", this.onClickUpSlideButton, this, 1, 0, 1);
            this.upSlideButton.setFrames("up_button_on", "up_button_off", "up_button_on", "up_button_off");
            this.add.existing( this.upSlideButton );

            this.downSlideButton = new Phaser.Button(this.game, 710, 780, "texture_atlas_5", this.onClickDownSlideButton, this, 1, 0, 1);
            this.downSlideButton.setFrames("down_button_on", "down_button_off", "down_button_on", "down_button_off");
            this.add.existing( this.downSlideButton );
        }

        this.blackLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.setTo(12, 16);

        this.add.tween( this.blackLayer ).to({alpha: 0}, 700,  Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.blackLayer.destroy();
            }, this);

        AudioManager.getInstance().playMusic(SoundTrack.MENUS);
    }

    public shutdown(): void {
        
        TrophyState.currentInstance = null;
                    
        super.shutdown();
    }

    public update(): void {

        super.update();

        if (this.confetti) {
            this.confetti.update();
        }
    }

    public removeIntroTrophies(): void {

        this.trophyIconsContainer.removeIntroTrophies();
    }

    public onIntroSeen(): void {

        GameManager.onIntroSeen();

        this.trophiesContainer.alpha = 0;
        this.trophiesContainer.visible = true;

        this.game.add.tween(this.trophiesContainer).to({alpha: 1}, 600,  Phaser.Easing.Cubic.Out, true, 300);
    }

    public onClickChangeTeamButton (tournament: string): void {

        GameManager.onClickChangeTeamButton(tournament);
        
        AudioManager.getInstance().playEffect("play");
    }

    public onClickIcon(iconIndex: number): void {

        this.trophiesContainer.onClickIcon(iconIndex);
    }

    public onMatchSelected(tournamentData: TournamentData, matchData: MatchData ): void {

        this.matchSelected = true;

        // salir de la escena con un delay
        this.game.time.events.add(650, function(): void {
            GameManager.onNewMatchSelected(tournamentData, matchData);
        }, this);
        
        AudioManager.getInstance().playEffect("play");
    }

    public addConfetti(): void {

        this.confetti = new Confetti(this.game);
        this.add.existing(this.confetti.foregroundConfettiContainer);
        this.add.existing(this.confetti.backgroundConfettiContainer);
        this.confetti.activate(6000);
    }

    public showNextTournament(): void {

        this.trophiesContainer.onSwipe(true);
    }

    public updateCreditsAfterAchievedTrophy(): void {

        GameManager.updateCreditsAfterAchievedTrophy();

        let creditsString: string = GameVars.formatNumber(GameVars.gameData.credits);

        this.creditsLabel.text = creditsString ;
        this.creditsLabel.x = 384 - this.creditsLabel.width / 2;
    }

    public goToScene(nextScene: string): void {
        
        this.blackLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.setTo(12, 16);
        this.blackLayer.alpha = 0;
        
        this.add.tween(this.blackLayer).to({alpha: 1}, 700,  Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.game.state.start(nextScene, true, false);
            }, this);
        
        this.game.state.start(nextScene, true, false);
    }

    private onClickBackButton(): void {

        this.goToScene("SplashState");
        AudioManager.getInstance().playEffect("play");
    }

    private onClickUpSlideButton(): void {

        if (!GameVars.gameData.introSeen || this.trophiesContainer.sliding) {
            return;
        }

        this.trophiesContainer.onSwipe(true);
        AudioManager.getInstance().playEffect("play");
    }

    private onClickDownSlideButton(): void {

        if (!GameVars.gameData.introSeen || this.trophiesContainer.sliding) {
            return;
        }

        this.trophiesContainer.onSwipe(false);
        AudioManager.getInstance().playEffect("play");
    }

    private addCredits(): void {

        let creditsCartridgeImage = new Phaser.Image(this.game, 384, 2 , "texture_atlas_5", "credits_cartridge" );
        creditsCartridgeImage.anchor.set(.5, 0);
        creditsCartridgeImage.scale.y = GameVars.scaleY;
        this.add.existing(creditsCartridgeImage);

        let creditsString  = GameVars.formatNumber(GameVars.gameData.credits);

        this.creditsLabel = new Phaser.Text(this.game, 384, 10,
            creditsString, { font: "36px Ubuntu", fontWeight: "700", fill: "#FFD51B", align: "center"});
        this.creditsLabel.x -= this.creditsLabel.width / 2;
        this.creditsLabel.scale.y = GameVars.scaleY;
        this.add.existing(this.creditsLabel);
    }

    private addFrame(): void {

        let frameGroup: Phaser.Group = this.add.group();

        let upperFrameImage: Phaser.Image =  new Phaser.Image(this.game, 0, 0, "texture_atlas_5", "vitrina_arriba");
        let leftFrameImage: Phaser.Image =  new Phaser.Image(this.game, 0, upperFrameImage.height, "texture_atlas_5", "vitrina_izquierda");
        let rightFrameImage: Phaser.Image =  new Phaser.Image(this.game, 768, upperFrameImage.height, "texture_atlas_5", "vitrina_derecha");
        rightFrameImage.anchor.set(1, 0);
        let bottomFrameImage: Phaser.Image =  new Phaser.Image(this.game, 0, upperFrameImage.height + rightFrameImage.height, "texture_atlas_5", "vitrina_abajo");

        frameGroup.add(upperFrameImage);
        frameGroup.add(leftFrameImage);
        frameGroup.add(rightFrameImage);
        frameGroup.add(bottomFrameImage);
    }
}
